<template>
  <div>
    <div
      class="box is-light wdt mb-4 has-text-centered"
      style="width: 600px; max-width: 100%; margin: auto;"
    >
      <div class="has-text-grey is-size-7 has-text-left is-uppercase">
        #{{ booking.bookingKey }}
      </div>

      <div class="is-size-5 mt-2 mb-4 has-text-centered">
        <div
          v-if="booking.trip && booking.trip.passengers"
          class="has-text-grey"
        >
          Booking for Passenger(s):
          <div
            v-for="(passenger, pIndex) in booking.trip.passengers"
            :key="pIndex"
            class="has-text-centered has-text-weight-semibold"
          >
            {{ passenger.firstName }} {{ passenger.lastName }}
          </div>
        </div>

        <div
          v-if="!hasTravel"
          class="has-text-weight-semibold mt-2 has-text-grey-dark mb-4"
        >
          Booking Failed
        </div>

        <div
          v-else-if="hasTravel && bookingComplete == false"
          class="my-5 is-size-6 is-default"
        >
          We were able to book part of your trip, but ran into some issues.
          Please verify your booking details below.
        </div>

        <div
          v-else-if="bookingComplete"
          class="is-size-4 mt-2 mb-4 has-text-centered"
        >
          Your Booking Has Been Successfully Completed
        </div>

        <div v-if="hasTravel">
          <StageStatus
            v-for="stage in bookingStages"
            :key="stage.slug"
            :stage="stage"
          />
        </div>

        <div v-if="exchangeSuccess" class="my-2 is-vcentered notification px-6 py-2">
          Need to update your car or hotel reservation? You can make further trip updates <span @click="viewTrip" class="is-inline has-text-primary is-clickable">directly in TripCircuit. </span>
        </div>

        <div class="mb-5">
          <TripCard
            v-if="hascityPhoto && !pathMixin_isMeeting"
            class="has-text-left"
            :trip="booking.trip"
          />

          <div
            v-else-if="booking.recordLocator"
            class="notification is-success is-light has-text-centered is-size-5 is-clickable"
            @click="viewTrip"
          >
            <div>Trip reference number:</div>
            <div class="has-text-weight-bold">
              {{ booking.recordLocator }}
            </div>
            <div v-if="!pathMixin_isMeeting" class="is-size-7">
              (view trip details)
            </div>
          </div>
        </div>

        <div
          v-if="hasTravel && bookingComplete == false"
          class="notification has-text-centered is-size-6 mb-5"
        >
          Please check your email for more information. If you need additional
          assistance, please contact us at one of the methods below to complete
          your booking.
        </div>

        <div
          v-if="!hasTravel"
          class="mb-5 notification is-light is-danger is-size-6"
        >
          We encountered an error with your booking and it has not been
          completed. Please try to submit your booking again or contact us using
          one of the methods below to complete your booking.
        </div>
        <AmadeusBookingErrors :bookingKey="booking.bookingKey" />
      </div>

      <p class="mb-2">
        Email Gant's Online Team:
        <a href="mailto:clientservices@ganttravel.com">
          clientservices@ganttravel.com
        </a>
      </p>
      <p class="mb-2">
        Contact Gant Travel directly for agent assistance at 877-924-0303
      </p>

    </div>
  </div>
</template>

<script>
import TripCard from "@/components/Trip/TripCard";
import StageStatus from "@/components/Itinerary/StageStatus";
import router from "@/router";
import AmadeusBookingErrors from "@/components/BookTravel/AmadeusBookingErrors.vue";

export default {
  name: "ConfirmationStatus",
  components: { TripCard, StageStatus, AmadeusBookingErrors },
  props: {
    booking: Object,
  },
  data: function() {
    return {};
  },
  computed: {
    hascityPhoto() {
      return this.booking.trip?.tripSummary?.photoUrl;
    },
    bookingStages() {
      let bookingStages = ["air", "hotel", "car", "ticket-exchange"];
      return this.booking.stages.filter((stage) => {
        return bookingStages.includes(stage.slug);
      });
    },
    //Check each air/car/hotel booking stage; true if at least one is complete
    hasTravel() {
      let hasTravel = false;
      let stages = this.bookingStages;
      stages.forEach((stage) => {
        if (stage.isComplete) {
          hasTravel = true;
        }
      });
      return hasTravel;
    },
    //Check each air/car/hotel booking stage; true if at least one is complete
    bookingComplete() {
      let complete = true;
      let stages = this.bookingStages;
      stages.forEach((stage) => {
        if (!stage.isComplete) {
          complete = false;
        }
      });
      return complete;
    },
    exchangeSuccess() {
      return this.booking.stages.some((stage) => {
        return stage.slug === "ticket-exchange" && stage.isComplete;
      });
    },
  },
  methods: {
    viewTrip() {
      if (this.pathMixin_isMeeting) {
        //TODO: add a meeting detail page
        //router.push({
        //  name: "meeting-detail",
        //  params: { meetingId: this.booking.meetingId },
        //});
      } else {
        //convert Amadeus recordLocator to hash to avoid showing true record locator in the url
        let hash = this.$helpers.encryptText(this.booking.recordLocator);

        router.push({
          name: "trip-detail",
          params: { recordLocatorHash: hash },
        });
      }
    },
  },
};
</script>

<style></style>
